//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { service } from "../services/api.js";
import SnackBar from "./SnackBar.vue";
import SnackBarMixin from "./SnackBarMixin.vue";
export default {
  extends: SnackBarMixin,
  components: {
    "snack-bar": SnackBar,
  },
  data() {
    return {
      dialog: false,
    };
  },
  watch: {
    dialog(val) {
      if (!val) return;
      this.wakeupBackendServer();
    },
  },
  methods: {
    emitBackendReady() {
      this.dialog = false;
      this.showSuccess("Backend Server Successfully Loaded");
      this.$emit("backendReady", true);
    },
    wakeupBackendServer() {
      service.wakeup().finally(() => {
        this.emitBackendReady();
      });
    },
  },
};
